import React from 'react'

export const Home = () => {
    return (
        <div id="home-container">
            <div id="content">
                <div className="details">
                    <div className="img-wrapper">
                        <img src="/images/me.jpg" alt="bright kapya" id="me" />
                    </div>
                    <div className="socials">
                        <a href="mailTo:kapyabright@outlook.com" className="social">
                            <span>
                                <i className="fas fa-envelope" style={{ color: '#00488b' }} />
                            </span>
                        </a>
                        <a
                            href="https://twitter.com/kapyabright"
                            rel="noopener noreferrer"
                            target="_blank"
                            className="social"
                        >
                            <i className="fab fa-twitter" style={{ color: '#1da1f2' }}></i>
                        </a>
                        <a
                            style={{ alignSelf: 'flex-end' }}
                            href="https://www.linkedin.com/in/bright-kapya-1158b1118/"
                            rel="noopener noreferrer"
                            target="_blank"
                            className="social"
                        >
                            <i className="fab fa-linkedin" style={{ color: '#0077b5' }} />
                        </a>
                        <a
                            style={{ alignSelf: 'flex-end' }}
                            href="https://github.com/KapyaB"
                            rel="noopener noreferrer"
                            target="_blank"
                            className="social"
                        >
                            <i className="fab fa-github github" style={{ color: '#56534e' }}></i>
                        </a>
                    </div>
                    <div className="links">
                        <a className="link"
                            href="https://play.google.com/store/apps/dev?id=7956905969763848838"
                            rel="noopener noreferrer"
                            target="_blank">
                            <i class="fab fa-google-play"></i>
                            Apps
                        </a>
                        <a className="link"
                            href="https://www.instagram.com/bryts_art/"
                            rel="noopener noreferrer"
                            target="_blank">
                            <i class="fas fa-paint-brush"></i>
                            Art
                        </a>
                        <a className="link"
                            href="/"
                            rel="noopener noreferrer"
                            target="_blank">
                            <i class="fas fa-pen-alt"></i>
                            Blog
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
